<template>
<!-- eslint-disable max-len -->
<div
  v-if="challengeLocked && (narratives.length === 0 || completedChallengeOutroNarrative)"
  class="lock-message"
>
  <div v-html="unlockMessage"></div>
</div>
<narrative-player
  v-else
  :narratives="narratives"
  :on-complete="onComplete"
>
</narrative-player>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import { getGroupUnlockDate, isGroupLocked } from '@/utils/challenge-locks';

import NarrativePlayer from '../narrative/NarrativePlayer';

export default {
  components: {
    NarrativePlayer
  },
  data() {
    return {
      completedChallengeOutroNarrative: false,
    };
  },
  computed: {
    ...mapGetters([
      'group',
      'activeClass',
      'currentChallengeIndex',
      'complete',
      'challenge',
      'lastChallenge'
    ]),
    narratives() {
      const challenge = this.complete ? this.challenge : this.lastChallenge;
      return challenge && challenge.outroNarratives || [];
    },
    challengeIndex() {
      return this.complete ? this.currentChallengeIndex : Math.max(0, this.currentChallengeIndex - 1);
    },
    currentChallengeLock() {
      if (this.activeClass == null || this.activeClass.challengeLocks == null
        || this.activeClass.challengeLocks.length === 0) {
        return null;
      }
      const l = this.activeClass.challengeLocks.find(
        el => el.challengeIndex === this.challengeIndex && el.outro
      );
      if (l) {
        l.unlockDate = new Date(l.unlockDate);
      }
      return l;
    },
    challengeLocked() {
      if (this.currentChallengeLock == null) {
        return false;
      }
      return isGroupLocked(this.group, this.currentChallengeLock);
    },
    timeStringOptions() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
    },
    challengeUnlockTimeString() {
      if (this.currentChallengeLock == null) {
        return (new Date(Date.now())).toLocaleString(undefined, this.timeStringOptions);
      }
      return getGroupUnlockDate(this.group, this.currentChallengeLock).toLocaleString(undefined, this.timeStringOptions);
    },
    unlockMessage() {
      const lockMessage =
        (this.currentChallengeLock && this.currentChallengeLock.lockMessageOverride)
          ? this.currentChallengeLock.lockMessageOverride
          : ((this.activeClass && this.activeClass.lockMessage)
            ? this.activeClass.lockMessage
            : 'You cannot progress further at this time. To continue, refresh after: {time}');
      return lockMessage.replace('{time}', this.challengeUnlockTimeString);
    },
  },
  methods: {
    ...mapMutations([
      'setRootLoadingMessage',
    ]),
    ...mapActions([
      'setLastChallengeOutroViewed',
      'setCurrentChallengeOutroViewed',
      'resetLastStateBeforeChallengeIntro'
    ]),
    async onComplete() {
      this.completedChallengeOutroNarrative = true;
      if (!(this.challengeLocked)) {
        this.setRootLoadingMessage('Please wait. Loading...');
        if (this.complete) await this.setCurrentChallengeOutroViewed();
        else await this.setLastChallengeOutroViewed();
        this.setRootLoadingMessage('');
        this.$router.nextGameState();
      }
    }
  },
  created() {
    this.resetLastStateBeforeChallengeIntro();
  }
};
</script>

<style lang="scss" scoped>
.lock-message {
  height: 900px;
  width: 100%;
  background-color: var(--primaryColor);
  color: white;
  font-size: 150%;
  text-shadow:
    black 0 0 12px,
    black 0 0 15px,
    black 0 0 18px,
    black 0 0 21px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/ChallengeOutro.vue